import { jsx as t, jsxs as b } from "react/jsx-runtime";
import { useTheme as T, Box as f, alpha as m, Typography as S, Avatar as w, Divider as k, Grow as j } from "@mui/material";
import { $ as z, X as I, D as v, e as A } from "../../../pointsGraph-DTJju-rA.js";
import { NotificationType as B } from "../../../helpers/daymaptypes.js";
import { useNotifications as C } from "../../../context/notifications/index.js";
import x from "react";
const F = ({ NotificationID: s, StudentID: o, Title: d, Message: n, NotificationType: i, SentAt: l, Read: e, onClick: a, inModal: p, Properties: h }) => {
  let { color: r, icon: D, iconType: u } = z(i, { fontSize: "small" });
  const { setRead: N } = C(), y = T();
  let c, g = n;
  return o ? c = /* @__PURE__ */ t(I, { studentId: o, color: r, icon: /* @__PURE__ */ t(v, { iconType: u, sx: { width: 17, height: 17 } }) }) : i === B.PeerToPeerMessage && h.SenderID ? (g = /* @__PURE__ */ t(f, { sx: { backgroundColor: m(y.palette.background.paper, 0.5) }, py: 0.5, px: 1, m: 0.5, children: /* @__PURE__ */ t(S, { fontWeight: 400, fontSize: ".8rem", children: n }) }), c = /* @__PURE__ */ t(I, { contactId: Number(h.SenderID), color: r, icon: /* @__PURE__ */ t(v, { iconType: u, sx: { width: 14, height: 14 } }) })) : c = /* @__PURE__ */ t(w, { variant: "rounded", sx: {
    height: 30,
    width: 30,
    bgcolor: e ? "transparent" : m(r, 0.15),
    color: e ? m(r, 0.45) : r
  }, children: D }), /* @__PURE__ */ t(
    A,
    {
      itemType: "notification",
      title: d,
      description: g,
      date: l,
      avatar: c,
      onClick: a,
      variant: e ? "subdued" : void 0,
      elevation: p ? 0 : 1,
      bgcolor: p ? "transparent" : void 0,
      unread: !e,
      onUnreadClicked: () => N(s)
    }
  );
}, U = ({ notifications: s, inModal: o, showStudent: d = !0, growIn: n }) => /* @__PURE__ */ t(f, { display: "flex", gap: 1, flexDirection: "column", children: s.map((i, l, e) => {
  const a = /* @__PURE__ */ b(x.Fragment, { children: [
    /* @__PURE__ */ t(F, { ...i, StudentID: d ? i.StudentID : void 0, inModal: o }, i.NotificationID),
    o && l + 1 < e.length && /* @__PURE__ */ t(k, { variant: "middle" })
  ] }, i.NotificationID);
  return n ? /* @__PURE__ */ t(x.Fragment, { children: /* @__PURE__ */ t(j, { in: !0, style: { transitionDuration: ".5s, 156ms" }, children: /* @__PURE__ */ t(f, { children: a }) }) }, i.NotificationID) : a;
}) });
export {
  F as NotificationItem,
  U as NotificationList
};
//# sourceMappingURL=notification.js.map
